import React from 'react';
import Picture from '../Picture.jsx';
import ContentMeta from '../ContentMeta.jsx';
import TranslatedLink from '../TranslatedLink.jsx';

export default class MediaItem extends React.PureComponent {
  render() {
    const { linkTemplate, routeParams, heading, images, post, linkText } = this.props;
    const square = require(`../../../assets/media-images/${images.square}`);

    return (
      <div className="col-md-6 media-item">
        <div className="highlight-box">
          <TranslatedLink className="text-colored-link" name={linkTemplate} routeParams={routeParams}>
            <h3 className="section">{heading}</h3>
          </TranslatedLink>
        </div>
        <TranslatedLink name={linkTemplate} routeParams={routeParams}>
          <Picture className="image" src={square} alt={heading}/>
        </TranslatedLink>
        <TranslatedLink className="text-colored-link" name={linkTemplate} routeParams={routeParams}>
          <h3 className="heading">{post.title}</h3>
          <p className="preamble">{post.preamble}</p>
        </TranslatedLink>
        <ContentMeta hideTags data={post}/>
        <TranslatedLink name={linkTemplate} routeParams={routeParams} className="more-link">
          {linkText}
        </TranslatedLink>
      </div>
    );
  }
}

MediaItem.propTypes = {
  linkTemplate: React.PropTypes.string,
  heading: React.PropTypes.string,
  routeParams: React.PropTypes.array,
  post: React.PropTypes.object,
  images: React.PropTypes.object,
  linkText: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/component/MediaPages/MediaItem.jsx